import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { css } from '@emotion/react';

import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import AddPaymentMethodModal from 'pages/Settings/Payment/ManageSubscription/AddPaymentMethod/AddPaymentMethodModal';

import PATHS from 'utils/paths';

import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import * as S from './ImportOrdersList.styled';

const ImportOrderVerifyModal = NiceModal.create(() => {
	const modal = useModal();
	const handleCloseModal = () => modal.remove();
	const navigate = useNavigate();

	return (
		<Modal maxWidth="small" fullwidth className="modal-import-verify-modal" closeButton={false}>
			<ModalTitle>
				<Typography variant="p1">ATTENTION</Typography>
			</ModalTitle>
			<ModalContent>
				<S.ModalContentContainer>
					<Image url="https://storage.googleapis.com/tryoto-public/public/assets/icons/modal-warning.svg" />
					<Typography variant="p2" noWrap>
						<Trans
							i18nKey="importOrdersVerifyModal.verifyMessageCRDoc"
							components={{
								linkViewer: (
									<S.LinkViewer
										onClick={() => {
											navigate(PATHS.GENERAL_SETTINGS);
											handleCloseModal();
										}}
									/>
								)
							}}
						/>
					</Typography>
					<Typography variant="p2" noWrap>
						<Trans
							i18nKey="importOrdersVerifyModal.verifyMessageClientCard"
							components={{
								linkViewer: (
									<S.LinkViewer
										onClick={() => {
											NiceModal.show(AddPaymentMethodModal, {
												customAlertText: 'imports.addSavedCardAlert'
											});
											handleCloseModal();
										}}
									/>
								)
							}}
						/>
					</Typography>
				</S.ModalContentContainer>
			</ModalContent>
			<ModalActions>
				<Button
					icon={faCheck}
					label="importOrdersVerifyModal.gotIt"
					onClick={handleCloseModal}
					css={css`
						.button-icon {
							transform: scaleX(1) !important;
						}
					`}
				/>
			</ModalActions>
		</Modal>
	);
});

export default ImportOrderVerifyModal;
